/*
  Björn Bites mountain parallax (snippets/bb-mountains.liquid).
  Each plane moves down by travel x depth x progress while the page scrolls, so the far
  mountains lag behind the near ones; the ground plane (depth 0) stays put. Stronger than
  the first bjornbites.se site (Jamie, 1 Oct).
  Horizon scrolls inside .page-wrapper on desktop (990 px and up) and the window on mobile,
  so the scroll position is read from whichever one is actually scrolling.
  Switched off for visitors who ask for reduced motion.
*/
(() => {
  if (window.bbMountainsReady) return;
  window.bbMountainsReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const smoothstep = (x) => (x <= 0 ? 0 : x >= 1 ? 1 : x * x * (3 - 2 * x));
  let items = [];
  let ticking = false;

  const scrollTopNow = () => {
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollTop > 0) return wrapper.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  };

  const collect = () => {
    items = Array.from(document.querySelectorAll('[data-mtn]')).map((host) => ({
      host,
      scene: host.closest('[data-mtn-scene]') || host,
      planes: Array.from(host.querySelectorAll('[data-depth]')).map((el) => ({
        el,
        depth: parseFloat(el.dataset.depth || '0'),
      })),
    }));
  };

  const update = () => {
    ticking = false;
    const viewportHeight = window.innerHeight;
    const scrollTop = scrollTopNow();
    for (const item of items) {
      const band = item.host.getBoundingClientRect();
      if (band.bottom < -viewportHeight || band.top > viewportHeight * 1.5) continue;
      const scene = item.scene.getBoundingClientRect();
      const sceneTop = scene.top + scrollTop;
      const travel = Math.min(viewportHeight * 0.6, band.height * 0.7);
      const start = Math.max(0, sceneTop - viewportHeight * 0.75);
      const progress = reduceMotion.matches ? 0 : smoothstep((scrollTop - start) / (viewportHeight * 0.8));
      for (const plane of item.planes) {
        const offset = Math.round(travel * plane.depth * progress * 10) / 10;
        plane.el.style.transform = `translate3d(0, ${offset}px, 0)`;
      }
    }
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const refresh = () => {
    collect();
    update();
  };

  // Capture phase catches scroll events from .page-wrapper as well as the window.
  document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  reduceMotion.addEventListener?.('change', update);

  // Theme editor: sections are re-rendered in place, so pick up new bands.
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => setTimeout(refresh, 0));

  refresh();
  setTimeout(update, 1200);
})();
